/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type UserRoleChange = {
    user_type: UserRoleChange.user_type;
};

export namespace UserRoleChange {

    export enum user_type {
        '_1' = 1,
        '_2' = 2,
        '_3' = 3,
        '_4' = 4,
        '_5' = 5,
    }


}
